import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { howItWorksSteps } from "@/lib/content";

export function HowItWorks() {
  return (
    <section id="how-it-works" aria-labelledby="how-it-works-heading" className="py-16 sm:py-24">
      <Container>
        <SectionHeading
          titleId="how-it-works-heading"
          eyebrow="How it works"
          title="Start with facts. Activate the right modules. Work the plan."
          description="The launch experience is designed to connect jurisdiction applicability, readiness and day-to-day privacy operations instead of treating each law as a separate spreadsheet."
        />

        <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {howItWorksSteps.map((item, index) => (
            <li
              key={item.step}
              className="relative min-w-0 rounded-xl border border-border bg-card p-6 shadow-card"
            >
              <span
                aria-hidden="true"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-foreground"
              >
                {item.step}
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>

              {index < howItWorksSteps.length - 1 && (
                <span
                  aria-hidden="true"
                  className="absolute right-[-1.4rem] top-9 hidden text-border lg:block"
                >
                  &rarr;
                </span>
              )}
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
